import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_wrkrs_sign_all_written_recs_of_disciplinary_actions_taken_ag'

export const dataPointDefinition = {
  retracedId: 'do_wrkrs_sign_all_written_recs_of_disciplinary_actions_taken_ag',
  name: 'Do workers sign all written records of disciplinary actions taken against them?',
  description:
    'In the event a disciplinary action results in a written record, i.e. "written warning", the intent of this question is to understand if workers acknowledge the record by signing it.\r\r\n\r\r\nFor example, if written warnings are communicated verbally to workers, but they do not physically sign the written warning (acknowledging their receipt of the warning), answer No.\r\r\n\r\r\nIf there is no example of disciplinary action, i.e. there has been no disciplinary action in the last months within this assessment period, but you have a policy/ procedure in place around recording keeping for disciplinary action and signing of records by workers, answer Yes.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11570,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
